import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Flex, Heading, Box, Text, Button, Image } from "@chakra-ui/react";
import { textSecondary, white, primary, textPrimary } from "../../utils/colors";
import Lottie from "lottie-react";
import noItemsFound from "../../assets/lottie/no-items-found.json";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import dentacasa from "../../assets/icons/dentacasa.svg";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("pageTitle.notFound")}</title>
        <meta name="description" content={t("pageDescription.notFound")} />
      </Helmet>

      <Box position="fixed" top="2.5rem" left="2.5rem" zIndex={1000}>
        <Link to="https://app.dentacasa.com" target="_blank">
          <Image src={dentacasa} h="1.5rem" w="initial" />
        </Link>
      </Box>

      <Flex w="100%" h="100vh" justifyContent="center" alignItems="center">
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="center"
          margin="0 auto 4rem"
        >
          {/* <Image src={images.noData} alt="no Data" /> */}
          <Box maxWidth="60%" margin="0 auto">
            <Lottie animationData={noItemsFound} loop={true} />
          </Box>

          <Heading
            fontSize="1.75rem"
            fontWeight="600"
            color={textPrimary}
            margin="1rem 0 0rem"
          >
            {t("noItems.page")}
          </Heading>
          <Text
            my={2}
            fontSize="1rem"
            color={textSecondary}
            fontWeight="500"
            textAlign={["center", "center"]}
          >
            {t("noItems.pageText")}
          </Text>
          <Button
            mt={2}
            minW="8rem"
            size="lg"
            bg={primary}
            color={white}
            fontSize="md"
            borderRadius="10rem"
            onClick={() =>
              navigate(
                localStorage.getItem("userInfo") ? "/select-tenant" : "/login"
              )
            }
          >
            {t("noItems.pageButton")}
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

export default NotFound;
